import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { fetchEnrolment, ENROLMENT_FETCH_REQUEST, ENROLMENT_FETCH_SUCCESS, ENROLMENT_FETCH_FAILURE } from './actions';
import { cancelLesson } from '../actions';
import { getChild } from '../reducer';
import PaymentView from './View';
import BackButton from '../../common/components/BackButton';

class Details extends Component {
	componentDidMount() {
		this.props.fetchEnrolment(Number(this.props.match.params.id));
		this.handleCancelLesson = this.handleCancelLesson.bind(this);
	}
	handleCancelLesson(lessonId) {
		const { cancelLesson } = this.props;
		const onSuccess = () => {
			this.props.fetchEnrolment(Number(this.props.match.params.id));
		}
		cancelLesson(lessonId, onSuccess);
	}
	render() {
		const { payment, enableUserTimeZone } = this.props;

		return <div>
			{payment && <PaymentView payment={payment} cancelLesson={this.handleCancelLesson} enableUserTimeZone={enableUserTimeZone}
				blockLessons={ENROLMENT_FETCH_REQUEST} unblockLessons={[ENROLMENT_FETCH_SUCCESS, ENROLMENT_FETCH_FAILURE]} />}
			<Row className='parent-dashboard-box'>
				<Col sm={12}>
					<BackButton />
				</Col>
			</Row>
		</div>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const paymentId = ownProps.match.params.id;
	const fromPath = ownProps.match.params.fromPath;

	const { parent, entities: { enrolments, centers, terms, grades }, configuration: { franchisor } } = state;

	const payment = enrolments[paymentId];
	if (payment) {
		payment.child = getChild(parent, payment.childId);

		if (payment.lesson) {
			payment.lesson.center = centers[payment.lesson.centerId];
			payment.lesson.term = terms[payment.lesson.termId];
			payment.lesson.grade = grades[payment.lesson.gradeId];
		}
	}

	return {
		payment,
		fromPath,
		enableUserTimeZone: franchisor && franchisor.enableUserTimeZone
	};
};

export default connect(mapStateToProps, {
	fetchEnrolment,
	cancelLesson
})(withTranslation()(Details));